import styled from "styled-components";
import { ColorsInterface } from "@/theme/colors";

interface ParagraphProps extends ColorsInterface {
  fontSize?: number;
  lineHeight?: number;
}

/**
 * Paragraph Component
 */

export const Paragraph = styled.p<ParagraphProps>`
  ${({ color = "black", theme, fontSize = 16, lineHeight = 24 }) => `
  color: ${theme.Colors[color]};
  font-family: ${theme.Fonts.ttNormsProNormal};
  font-size: ${fontSize}px;
  line-height: ${lineHeight}px;
  `}
`;
